var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import axios from 'axios';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/DefineCurrentVersionEnums';
import moment from 'moment';
let DefineCurrentVersionModule = class DefineCurrentVersionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.defineCurrentVersionList = [];
        this.defineCurrentVersionId = [];
        this.defineCurrentVersionDesc = [];
        this.defineCurrentVersionYear = [];
        this.selectedCategoryId = [];
        this.selectedCategoryDesc = [];
        this.selectedCategoryYear = [];
        this.useFilter = true;
        this.defineCurrentVersionPaging = [];
        this.loadPage = false;
        this.page = 1;
        this.size = 10;
        this.desc = '';
        this.searchBy = '';
        this.status = '';
        this.statusMessage = '';
        this.listVersionLookup = [];
    }
    get getDefineCurrentVersionWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getDefineCurrentVersionLoading() {
        return this.loading;
    }
    get getDefineCurrentVersionDataList() {
        return this.defineCurrentVersionList;
    }
    get getDefineCurrentVersionListId() {
        return this.defineCurrentVersionId;
    }
    get getDefineCurrentVersionListDesc() {
        return this.defineCurrentVersionDesc;
    }
    get getDefineCurrentVersionListYear() {
        return this.defineCurrentVersionYear;
    }
    get getDefineCurrentVersionSelectedId() {
        return this.selectedCategoryId;
    }
    get getDefineCurrentVersionSelectedDesc() {
        return this.selectedCategoryDesc;
    }
    get getDefineCurrentVersionYear() {
        return this.selectedCategoryYear;
    }
    get getDefineCurrentVersionPaging() {
        return this.defineCurrentVersionPaging;
    }
    get getDefineCurrentVersionSize() {
        return this.size;
    }
    get getDefineCurrentVersionDesc() {
        return this.desc;
    }
    get getDefineCurrentVersionSearchBy() {
        return this.searchBy;
    }
    get getDefineCurrentVersionStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getDefineCurrentVersionUseFilter() {
        return this.useFilter;
    }
    get getListVersionLookup() {
        return this.listVersionLookup;
    }
    [_a = Mutations.SET_DEFINE_CURRENT_VERSION_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_DEFINE_CURRENT_VERSION_LOADING](payload) {
        this.loading = payload;
    }
    [_c = Mutations.SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_d = Mutations.SET_DEFINE_CURRENT_VERSION_LIST](payload) {
        this.defineCurrentVersionList = payload;
    }
    [_e = Mutations.SET_DEFINE_CURRENT_VERSION_LIST_ID](payload) {
        this.defineCurrentVersionId = payload;
    }
    [_f = Mutations.SET_DEFINE_CURRENT_VERSION_LIST_DESC](payload) {
        this.defineCurrentVersionDesc = payload;
    }
    [_g = Mutations.SET_DEFINE_CURRENT_VERSION_LIST_YEAR](payload) {
        this.defineCurrentVersionYear = payload;
    }
    [_h = Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_ID](payload) {
        this.selectedCategoryId = payload;
    }
    [_j = Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_DESC](payload) {
        this.selectedCategoryDesc = payload;
    }
    [_k = Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_YEAR](payload) {
        this.selectedCategoryYear = payload;
    }
    [_l = Mutations.SET_DEFINE_CURRENT_VERSION_PAGE](payload) {
        this.defineCurrentVersionPaging = payload;
    }
    [_m = Mutations.SET_DEFINE_CURRENT_VERSION_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_o = Mutations.SET_DEFINE_CURRENT_VERSION_STATUS](payload) {
        this.status = payload.status;
        this.statusMessage = payload.message;
    }
    [_p = Mutations.SET_DEFINE_CURRENT_VERSION_SIZE](payload) {
        this.size = payload;
    }
    [_q = Mutations.SET_DEFINE_CURRENT_VERSION_USE_FILTER](payload) {
        this.useFilter = payload;
    }
    [_r = Mutations.SET_DEFINE_CURRENT_VERSION_LOOKUP](payload) {
        this.listVersionLookup = payload;
    }
    [_s = Mutations.SET_DEFINE_CURRENT_VERSION_DESC](payload) {
        this.desc = payload;
    }
    [_t = Mutations.SET_DEFINE_CURRENT_VERSION_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_u = Actions.GET_DEFINE_CURRENT_VERSION_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOADING, true);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion`;
            const params = {
                ver: 'v1',
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: this.desc
            };
            const sortingDate = (value) => {
                return moment(value).format('YYYY-MM');
            };
            return new Promise((resolve, reject) => {
                ApiService.get(url, '', new URLSearchParams(params).toString())
                    .then((res) => {
                    if (res.status === 200) {
                        const data = res.data.result.content.data.map((e) => {
                            return Object.assign(Object.assign({}, e), { periodSort: sortingDate(`${e.year}-${e.periodFrom}`) });
                        });
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST, data);
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_PAGE, res.data.result.content.paging);
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOADING, false);
                    reject(false);
                });
            });
        });
    }
    [_v = Actions.GET_DEFINE_CURRENT_VERSION_LIST_ID_DESC]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_ID, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_DESC, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_YEAR, []);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '999999',
                Desc: this.desc,
                SearchBy: this.searchBy,
                versions: [],
                budgetTypeDesc: [],
                years: []
            };
            const dataId = [];
            const dataDesc = [];
            const dataYear = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _10;
                    if (res.status === 200) {
                        (_10 = res.data.result.content) === null || _10 === void 0 ? void 0 : _10.data.map((data) => {
                            if (dataId.length === 0) {
                                dataId.push({
                                    value: data.version,
                                    label: data.version
                                });
                            }
                            else {
                                const findId = dataId.find((element) => {
                                    return element.value === data.version;
                                });
                                if (findId === undefined) {
                                    dataId.push({
                                        value: data.version,
                                        label: data.version
                                    });
                                }
                            }
                            if (dataDesc.length === 0) {
                                dataDesc.push({
                                    value: data.budgetTypeDesc,
                                    label: data.budgetTypeDesc
                                });
                            }
                            else {
                                const findDesc = dataDesc.find((element) => {
                                    return element.value === data.budgetTypeDesc;
                                });
                                if (findDesc === undefined) {
                                    dataDesc.push({
                                        value: data.budgetTypeDesc,
                                        label: data.budgetTypeDesc
                                    });
                                }
                            }
                            if (dataYear.length === 0) {
                                dataYear.push({
                                    value: data.year,
                                    label: data.year
                                });
                            }
                            else {
                                const findYear = dataYear.find((element) => {
                                    return element.value === data.year;
                                });
                                if (findYear === undefined) {
                                    dataYear.push({
                                        value: data.year,
                                        label: data.year
                                    });
                                }
                            }
                        });
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_ID, dataId);
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_DESC, dataDesc);
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_YEAR, dataYear);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_w = Actions.CREATE_DEFINE_CURRENT_VERSION_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_x = Actions.UPDATE_DEFINE_CURRENT_VERSION_LIST](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    if (res) {
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_STATUS, {
                            status: res.data.statusCode,
                            message: res.data.result.message
                        });
                        this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_y = Actions.GET_DEFINE_CURRENT_VERSION_LIST_FILTER](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_ID, data.versions);
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_DESC, data.budgetTypeDesc);
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_YEAR, data.years);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                versions: data.versions,
                budgetTypeDesc: data.budgetTypeDesc,
                years: data.years
            };
            const sortingDate = (value) => {
                return moment(value).format('YYYY-MM');
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        const data = res.data.result.content.data.map((e) => {
                            return Object.assign(Object.assign({}, e), { periodSort: sortingDate(`${e.year}-${e.periodFrom}`) });
                        });
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST, data);
                        if (!this.loadPage) {
                            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOAD_PAGE, true);
                            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_PAGE, res.data.result.content.paging);
                        }
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_PAGE, res.data.result.content.paging);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_z = Actions.GET_DEFINE_CURRENT_VERSION_DATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.useFilter) {
                this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_LIST);
            }
            else {
                this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_LIST_FILTER, {
                    versions: this.selectedCategoryId,
                    budgetTypeDesc: this.selectedCategoryDesc,
                    years: this.selectedCategoryYear
                });
            }
        });
    }
    [_0 = Actions.UPDATE_SELECTED_DEFINE_CURRENT_VERSION_ID](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_ID, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
        });
    }
    [_1 = Actions.UPDATE_SELECTED_DEFINE_CURRENT_VERSION_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_DESC, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
        });
    }
    [_2 = Actions.UPDATE_SELECTED_DEFINE_CURRENT_VERSION_YEAR](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_YEAR, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
        });
    }
    [_3 = Actions.UPDATE_DEFINE_CURRENT_VERSION_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_SIZE, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
        });
    }
    [_4 = Actions.RESET_DEFINE_CURRENT_VERSION_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_ID, []);
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_DESC, []);
            this.context.commit(Mutations.SET_SELECTED_DEFINE_CURRENT_VERSION_YEAR, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_DATA);
        });
    }
    [_5 = Actions.GET_DEFINE_CURRENT_VERSION_LOOKUP](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOOKUP, []);
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion/lookup?ver=v1`;
            const dataVersion = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, data).then((res) => {
                    if (res.status === 200) {
                        res.data.result.content.map((data) => {
                            dataVersion.push({
                                value: data.version,
                                label: data.version
                            });
                        });
                        this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LOOKUP, dataVersion || []);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                });
            });
        });
    }
    [_6 = Actions.DOWNLOAD_DEFINE_CURRENT_VERSION]() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/fincapex/api/master/currentversion/download?ver=v1`;
            axios({
                url: apiUrl,
                method: 'POST',
                responseType: 'blob',
                data: {
                    versions: this.selectedCategoryId,
                    budgetTypeDesc: this.selectedCategoryDesc,
                    years: this.selectedCategoryYear
                }
            }).then((response) => {
                // eslint-disable-next-line comma-spacing
                const fileName = response.headers['content-disposition']
                    .split('; ')[1]
                    .split('=')[1]
                    .replaceAll('/', '-')
                    .replaceAll('"', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        });
    }
    [_7 = Actions.UPDATE_DEFINE_CURRENT_VERSION_BUDGET](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_SEARCH_BY, 'BudgetTypeDesc');
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_DESC, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_ID, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_DESC, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_YEAR, []);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_LIST_ID_DESC);
        });
    }
    [_8 = Actions.UPDATE_DEFINE_CURRENT_VERSION_YEAR](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_SEARCH_BY, 'year');
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_DESC, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_ID, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_DESC, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_YEAR, []);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_LIST_ID_DESC);
        });
    }
    [_9 = Actions.UPDATE_DEFINE_CURRENT_VERSION_VERSION](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_SEARCH_BY, 'code');
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_DESC, data);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_ID, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_DESC, []);
            this.context.commit(Mutations.SET_DEFINE_CURRENT_VERSION_LIST_YEAR, []);
            this.context.dispatch(Actions.GET_DEFINE_CURRENT_VERSION_LIST_ID_DESC);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _r, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _s, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _x, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _y, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _z, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _0, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _1, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _2, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _3, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _4, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _5, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _6, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _7, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _8, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _9, null);
DefineCurrentVersionModule = __decorate([
    Module
], DefineCurrentVersionModule);
export default DefineCurrentVersionModule;
